import styled from "styled-components/macro";

export const LeftMenu = styled.div`
  top: calc(${(props) => props.theme.sizes.heightHeaderDesktop});
  align-self: flex-start;
  width: 248px;
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  border: 1px solid ${(props) => props.theme.colors.border};
  background-color: ${(props) => props.theme.colors.place};
  padding: 24px 16px;
  @media ${(props) => props.theme.media.leftmenu} {
    display: none;
  }
  & > ul {
    margin: 0;
    & > li {
      list-style-type: none;
    }
  }
  & a {
    text-decoration: none;
    padding: 8px 8px 8px 16px;
    cursor: pointer;
    display: block;
    position: relative;
    border-radius: 4px;
    margin-bottom: 8px;
    &.active,
    &.keep {
      background-color: ${(props) => props.theme.colors.secondary};
      label {
        font-weight: 600;
      }
    }
    &.restriction {
      background-color: ${(props) => props.theme.colors.place};
      label {
        font-weight: 100;
        color: ${(props) => props.theme.colors.textDimmed};
      }
    }
    &:hover {
      background-color: ${(props) => props.theme.colors.secondary};
    }
    &.restriction:hover:before {
      content: "You need to fill out a profile";
      position: absolute;
      right: -40%;
      color: ${(props) => props.theme.colors.place};
      background-color: ${(props) => props.theme.colors.thirdly};
      padding: 6px;
      border-radius: 4px;
    }
  }
`;

export const ContainerLeftSide = styled.div`
  position: sticky;
  top: calc(${(props) => props.theme.sizes.heightHeaderDesktop});
  align-self: flex-start;
  width: 248px;
  @media ${(props) => props.theme.media.leftmenu} {
    display: none;
  }
  }
`;
